<div class="page-layout">
  <app-toast></app-toast>
  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar
      pageTitle="Policy & Flows"
      pageSubtitle="Review the policies and process flows extracted from your documents."
    ></app-navbar>

    <div class="content-wrap">
      <app-pending-reviews-banner [refreshNote]="true"></app-pending-reviews-banner>
      <!-- ── Rebuild bar ── -->
      <div class="rebuild-bar">
        <div class="rb-left">
          <div class="rb-state">
            <span class="rb-dot" [ngClass]="status()?.state | lowercase"></span>
            <span class="rb-state-text">
              <ng-container [ngSwitch]="status()?.state">
                <span *ngSwitchCase="'Running'">Rebuild running…</span>
                <span *ngSwitchCase="'Succeeded'">Last rebuild succeeded</span>
                <span *ngSwitchCase="'Failed'">Last rebuild failed</span>
                <span *ngSwitchDefault>Idle</span>
              </ng-container>
            </span>
          </div>

          <div class="rb-counts" *ngIf="status()?.lastResult as r">
            <span class="rb-count"><b>{{ r.chunk_count }}</b> chunks</span>
            <span class="rb-count"><b>{{ r.policy_count }}</b> policies</span>
            <span class="rb-count"><b>{{ r.flow_count }}</b> flows</span>
            <span class="rb-count"><b>{{ r.step_count }}</b> steps</span>
            <span class="rb-count"><b>{{ r.transition_count }}</b> transitions</span>
            <span class="rb-count"><b>{{ r.governs_edge_count }}</b> governs</span>
          </div>

          <div class="rb-error" *ngIf="status()?.state === 'Failed' && status()?.error">
            {{ status()?.error }}
          </div>
        </div>

        <div class="rb-right">
          <span class="rb-spinner" *ngIf="isRunning()" aria-hidden="true"></span>
          <app-button
            variant="primary"
            [disabled]="isRunning()"
            (clicked)="askRebuild()"
          >{{ isRunning() ? 'Rebuilding…' : 'Rebuild graph' }}</app-button>
        </div>
      </div>

      <!-- ── Tabs ── -->
      <nav class="tabs">
        <button type="button" [class.on]="activeTab() === 'policies'" (click)="setTab('policies')">
          Policies <span class="tab-n">{{ policies().length }}</span>
        </button>
        <button type="button" [class.on]="activeTab() === 'flows'" (click)="setTab('flows')">
          Flows <span class="tab-n">{{ flows().length }}</span>
        </button>
        <button type="button" [class.on]="activeTab() === 'graph'" (click)="setTab('graph')">
          Graph
        </button>
      </nav>

      <!-- ── Views ── -->
      <div class="view-card">
        <div class="loading" *ngIf="isLoadingGraph()">Loading graph…</div>

        <ng-container *ngIf="!isLoadingGraph()">
          <app-policy-review-table
            *ngIf="activeTab() === 'policies'"
            [policies]="policies()"
            [pendingIds]="pendingPolicyIds()"
            (review)="onReviewPolicy($event)"
          ></app-policy-review-table>

          <app-flow-view
            *ngIf="activeTab() === 'flows'"
            [flows]="flows()"
            [governs]="governs()"
            [policies]="policies()"
            [pendingIds]="pendingFlowIds()"
            (reviewFlow)="onReviewFlow($event)"
          ></app-flow-view>

          <app-policy-graph
            *ngIf="activeTab() === 'graph'"
            [graph]="graph()"
          ></app-policy-graph>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- ── Rebuild confirm ── -->
  <div class="modal-overlay" *ngIf="showConfirm()" (click)="cancelRebuild()">
    <div class="modal" (click)="$event.stopPropagation()">
      <h3 class="modal-title">Rebuild policy &amp; flow graph?</h3>
      <p class="modal-body">
        This re-runs LLM extraction over every ingested chunk and can take several minutes for
        large tenants.
        <ng-container *ngIf="status()?.lastResult as r">
          The last run processed <b>{{ r.chunk_count }}</b> chunks.
        </ng-container>
        Existing review approvals may be reset by the new run.
      </p>
      <div class="modal-actions">
        <app-button variant="muted" (clicked)="cancelRebuild()">Cancel</app-button>
        <app-button variant="primary" (clicked)="confirmRebuild()">Start rebuild</app-button>
      </div>
    </div>
  </div>
</div>
